import { ApiMethods, ApiTags, appAPI } from '.';

export interface McpConnection {
  id: string;
  clientName: string;
  createdAt: string;
}

export const mcpConnectionsApi = appAPI.injectEndpoints({
  endpoints: (build) => ({
    getMcpConnections: build.query<McpConnection[], void>({
      query: () => ({
        path: '/portal/mcp-connections',
        method: ApiMethods.get,
        options: {},
      }),
      providesTags: [ApiTags.mcpConnections],
    }),
    revokeMcpConnection: build.mutation<void, string>({
      query: (id) => ({
        path: `/portal/mcp-connections/${id}`,
        method: ApiMethods.del,
        options: {},
      }),
      invalidatesTags: [ApiTags.mcpConnections],
    }),
  }),
});

export const { useGetMcpConnectionsQuery, useRevokeMcpConnectionMutation } =
  mcpConnectionsApi;
